import { render, staticRenderFns } from "./AccessoEPermessi.vue?vue&type=template&id=0224eb26&"
import script from "./AccessoEPermessi.vue?vue&type=script&lang=js&"
export * from "./AccessoEPermessi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports